export default __webpack_public_path__ + "static/media/remove-icon.b935cafa.svg";